import { render, staticRenderFns } from "./awardSelector.vue?vue&type=template&id=1c9070f9&scoped=true&"
import script from "./awardSelector.vue?vue&type=script&lang=js&"
export * from "./awardSelector.vue?vue&type=script&lang=js&"
import style0 from "./awardSelector.vue?vue&type=style&index=0&lang=css&"
import style1 from "./awardSelector.vue?vue&type=style&index=1&id=1c9070f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9070f9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\200xth\\xth2.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c9070f9')) {
      api.createRecord('1c9070f9', component.options)
    } else {
      api.reload('1c9070f9', component.options)
    }
    module.hot.accept("./awardSelector.vue?vue&type=template&id=1c9070f9&scoped=true&", function () {
      api.rerender('1c9070f9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/activity/components/awardSelector.vue"
export default component.exports